var map = {
	"./_animation.scss": "./source/global/styles/variables/css/_animation.scss",
	"./_colors.scss": "./source/global/styles/variables/css/_colors.scss",
	"./_dimensions.scss": "./source/global/styles/variables/css/_dimensions.scss",
	"./_fonts.scss": "./source/global/styles/variables/css/_fonts.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./source/global/styles/variables/css sync recursive ^\\.\\/.*$";